// ChooseLocation.js
import React, { useEffect, useState, useRef } from "react";
import MenuHeader from "./MenuHeader";
import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import UserService from "../services/user.service";
import PromotionService from "../services/promotion.service";
import cantons from "../shared/data/cantons.json";
import { useNotifications } from '../context/NotificationProvider';
import { addressFormat, asTitle, castDate } from '../shared/utils/string';
import { Map } from "./google_map";
import axios from "../api/axios";
import Select from 'react-select';
import FicheClientService from "../services/fiche_client.service";
import BookingService from "../services/booking.service";
import useApi from "../hooks/useApi";
import imageFile from "../assets/images/upload-file.svg";
import { useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import Autocomplete from 'react-google-autocomplete';
import { useLoadScript } from '@react-google-maps/api';
import { Menu, MenuList, MenuItem, IconButton, ListItemText, ListItemIcon, Divider, TextField, Button } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import HistoryIcon from '@mui/icons-material/History';
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Papa from 'papaparse';
import { useTranslatableData } from "../hooks/useTranslatable";
import StatusBadge from "./TaskList/StatusBadge";

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    maxHeight: "95vh",
    scrollbarWidth: "none",
  },
};

const historyModalStyles = {
  content: {
    ...customStyles.content,
    width: "min(92vw, 1180px)",
    maxWidth: "1180px",
    maxHeight: "88vh",
    overflow: "hidden",
    padding: "28px 32px",
  },
};

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#8fa9b9",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
}));

const Customer = () => {
  const { t } = useTranslation(['customers', 'dashboard']);
  const api = useApi();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
  const openHistoryRequested = searchParams.get("history") === "1";
  const autoHistoryOpenedRef = useRef(false);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const notify = useNotifications();
  const [customers, setCustomers] = useState([]); // État pour stocker les données des clients
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);
  const [total, setTotal] = useState(0);
  const [lastPage, setLastPage] = useState(1);
  const [customerBookings, setCustomerBookings] = useState([]);
  const [selectedHistoryBookingId, setSelectedHistoryBookingId] = useState(null);

  const translatedBookings = useTranslatableData(customerBookings, ['product.name']);

  const [ficheFormData, setFicheFormData] = useState({
    id: '',
    user_id: '',
    parking: '',
    maison_ou_immeuble: '',
    infos_logistiques: '',
    tensions_particulieres: '',
    pression_ideale: '',
    huile_preferee: '',
    type_musique: '',
    problemes_physique: '',
    parties_preferees: '',
    parties_a_ne_pas_masser: '',
    se_fait_masser_nu: '',
    mauvaise_hygiene: '',
    remarque_deplacee: '',
    age: '',
    type_profession: '',
    source: '',
    classe_sociale: '',
    parking_on: '',
    infos_logistiques_on: '',
    maison_ou_immeuble_on: '',
    problemes_physique_on: '',
    couleur_on: '',
    forme_on: '',
    cuticules_on: '',
    ongle_on: '',
    age_on: '',
    type_on: '',
    entendu_on: '',
    classe_on: '',
    info_on: '',
    info_complementaires: '',
  });


  const [formData, setFormData] = useState({
    id: null,
    civility: null,
    firstname: "",
    lastname: "",
    phone: "",
    email: "",
    birthdate: "",
    zip_code: "",
    state: "",
    state_code: "",
    street: "",
    street_number: "",
    city: "",
    country: "Switzerland",
    country_code: "CH",
    role: "ROLE_CLIENT",
    latitude: null,
    longitude: null
  });
  const [hoveredRow, setHoveredRow] = useState(null);
  const [isZipCodeVisible, setIsZipCodeVisible] = useState(false);
  const [filterData, setFilterData] = useState({
    search: "",
    search_by: "name",
    operator: "contains",
    status: "",
  });

  const [filters, setFilters] = useState({
    with: 'primary_address,media,id,ficheClient',
    page: currentPage,
    per_page: perPage,
    id: id ? `in:${id}` : "",
    sort: '-created_at',
  });
  const [isAddressUpdate, setIsAddressUpdate] = useState(false);
  const [coordinates, setCoordinate] = useState({
    lat: 46.356,
    lng: 6.5641
  });

  const customSelectStyles = {
    control: (styles) => ({
      ...styles,
      width: '100%',
      height: '60px',
      padding: '0 15px',
      fontSize: '14px',
      lineHeight: '60px',
      color: '#393D44',
      border: '0',
      borderRadius: '20px',
      background: '#ffffff',
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: 'none',
    }),
    placeholder: (base) => ({
      ...base,
      marginTop: '-10px',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      marginTop: '-10px',
    }),
  };
  const [selectedState, setSelectedState] = useState(null);
  const [showMap, setShowMap] = useState(false);
  const [sortDirection, setSortDirection] = useState(true);
  const timeoutRef = useRef(null);

  const [detailsModalIsOpen, setDetailsModalIsOpen] = useState(false);
  const [detailsModalIsOpenFiche, setDetailsModalIsOpenFiche] = useState(false);

  const [historyModalIsOpen, setHistoryModalIsOpen] = useState(false);
  const [promoMap, setPromoMap] = useState({});
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY, // Ensure you use your actual API Key
    libraries: ['places'],
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);



  /* ========================================== */

  const handleNextPage = () => {
    setFilters({ ...filters, page: currentPage + 1 });
    setCurrentPage(currentPage + 1);
  }

  const handlePrevPage = () => {
    setFilters({ ...filters, page: currentPage - 1 });
    setCurrentPage(currentPage - 1);
  }

  const handleLastPage = () => {
    setFilters({ ...filters, page: lastPage });
    setCurrentPage(lastPage);
  }

  const handleFirstPage = () => {
    setFilters({ ...filters, page: 1 });
    setCurrentPage(1);
  }

  const handlePerPageChange = (e) => {
    setFilters({ ...filters, per_page: e.target.value, page: 1 });
    setPerPage(e.target.value);
    setCurrentPage(1);

  }

  const handleDownload = async (e) => {
    try {
      e.preventDefault();

      const exportFilters = { ...filters };
      delete exportFilters.page;
      delete exportFilters.per_page;

      const response = await UserService.export(
        { ...exportFilters, 'roles.name': 'ROLE_CLIENT' },
        api
      );

      let csvData = response;

      const parsed = Papa.parse(csvData, { header: false });

      let filteredData = parsed.data;

      filteredData = filteredData.map((row) => {
        if (!Array.isArray(row) || row.length === 0) return row;
        return row.map((cell) => {
          if (typeof cell === 'string') {
            return cell.replace(/[\r\n]+/g, ' ').trim();
          }
          return cell;
        });
      });

      csvData = Papa.unparse(filteredData);
      const csvBlob = new Blob([csvData], { type: 'text/csv' });

      const link = document.createElement('a');
      link.href = URL.createObjectURL(csvBlob);
      link.download = 'clients.csv';
      document.body.appendChild(link);
      link.click();
      link.remove();

    } catch (error) {
      console.error('Error exporting client bookings:', error);
    }
  };

  const handlePhoneChange = (value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      phone: value, // Update the phone field
    }));
  };
  const handleSelectedSort = async (event) => {
    const selected = document.querySelector('.sort-header.active');
    const selectedColumn = event.currentTarget.id;
    let direction = true;
    if (selected.id != selectedColumn) {
      selected.classList.remove('active');
      event.currentTarget.classList.add('active');
      setSortDirection(true);
    } else {
      setSortDirection(!sortDirection);
      direction = !sortDirection;
    }
    if (selectedColumn != 'name') {
      setFilters({ ...filters, sort: `${direction ? '' : '-'}${selectedColumn}` })
      filters.sort = `${direction ? '' : '-'}${selectedColumn}`;
    } else {
      setFilters({ ...filters, sort: `${direction ? '' : '-'}firstname,${direction ? '' : '-'}lastname` })
      filters.sort = `${direction ? '' : '-'}firstname,${direction ? '' : '-'}lastname`;
    }
    await fetchCustomersSort();
  }
  const handleStateChange = (data) => {
    setIsAddressUpdate(true);
    let selected = cantons.cantons.find(
      (canton) => canton.name === data?.value
    );
    document.querySelector('input[name="zip_code"]').setAttribute('placeholder', selected?.zip_code_range || '');
    setFormData({
      ...formData, zip_code: ''
    });
    setFormData({
      ...formData,
      state: data?.value,
    });
    setSelectedState(data);
  };
  // Fonction pour mettre à jour les valeurs du formulaire
  const handleChange = async (e) => {

    const updatedCivility = e.target.name === 'civility' ? (formData.civility === e.target.value ? "" : e.target.value) : formData.civility;

    const updatedFormData = {
      ...formData,
      [e.target.name]: e.target.value,
      civility: updatedCivility,
    };

    if (formData.id && e.target.name === 'zip_code' || e.target.name === 'street' || e.target.name === 'street_number' || e.target.name === 'city') {
      setIsAddressUpdate(true);
    }

    // Handle file input
    if (e.target.name === "file") {
      console.log({ e });
      const file = e.target.files[0];
      if (file) {
        setFileName(file.name);
        setFile(file);
      }
    } else {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    }

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    setFormData(updatedFormData);
  };

  const handleChangeFiche = async (e) => {

    setFicheFormData({
      ...ficheFormData,
      [e.target.name]: e.target.value,
    });

  };

  const handleSubmit = async (e) => {
    e.preventDefault();


    formData.birthdate = formData.birthdate === '' ? null : formData.birthdate;
    formData.role = 'ROLE_CLIENT';
    formData.country = "Switzerland";
    formData.country_code = "CH";

    const formDataToSend = new FormData();

    for (const key in formData) {
      const value = formData[key];
      if (value) {
        if (Array.isArray(value) || typeof value === 'object') {
          formDataToSend.append(key, JSON.stringify(value));
        } else if (typeof value === 'boolean') {
          formDataToSend.append(key, Number(value)); // Convert boolean to string
        } else {
          formDataToSend.append(key, value);
        }
      }
    }

    if (file) {
      formDataToSend.append("imageFile", file);
    }

    try {
      const response = await (formData.id ? UserService.updateWithImage(formData.id, file ? formDataToSend : formData, file ? api : api) : UserService.store(file ? formDataToSend : formData, file ? api : api));
      if (response.data) {
        closeModal();
        fetchCustomers();
      }
    } catch (e) {
      // errors handled in interceptor
    }
  };

  const handleSubmitFiche = async (e) => {
    e.preventDefault();

    try {
      // const response = await FicheClientService.store({ ...ficheFormData, user_id: selectedCustomer.id }, api);
      const response = await (ficheFormData.id ? FicheClientService.update(ficheFormData.id, { ...ficheFormData, user_id: selectedCustomer.id }, api) : FicheClientService.store({ ...ficheFormData, user_id: selectedCustomer.id }, api));
      if (response.data) {
        closeFichesModal();
        fetchCustomers();
      }
    } catch (e) {
      // errors handled in interceptor
    }
  };

  const fetchCustomersSort = async () => {
    try {
      const response = await UserService.indexByRole(filters, 'ROLE_CLIENT', api);
      setCustomers(response.data);
      console.log("cosoto", response)
      setTotal(response.total);
      setLastPage(response.last_page);
      if (response.last_page < currentPage) {
        setFilters({ ...filters, page: response.last_page })
        setCurrentPage(response.last_page);
      }
    } catch (error) {
      console.error("Erreur lors du chargement des clients:", error);
    }
  };

  const fetchCustomers = async () => {
    try {
      const response = await UserService.indexByRole(filters, 'ROLE_CLIENT', api);

      setCustomers(response.data);
      console.log(response)
      setTotal(response.total);
      setLastPage(response.last_page);
      if (response.last_page < currentPage) {
        setFilters({ ...filters, page: response.last_page })
        setCurrentPage(response.last_page);
      }
    } catch (error) {
      console.error("Erreur lors du chargement des clients:", error);
    }
  };



  // Fonction pour calculer la date minimale (18 ans avant aujourd'hui)
  const calculateMinDate = () => {
    const today = new Date();
    const minDate = new Date(
      today.getFullYear() - 18, // Soustraire 18 ans à l'année actuelle
      today.getMonth(),
      today.getDate()
    );
    return minDate.toLocaleDateString('en-CA').split("T")[0]; // Formater la date en YYYY-MM-DD
  };
  // Requête API pour obtenir les clients avec pagination
  useEffect(() => {
    fetchCustomers();
  }, [currentPage, perPage]); // Recharger les données à chaque changement de page

  function openModal(customer) {
    if (customer && customer?.id) {
      let phone = customer.phone;
      if (phone && phone.startsWith("0")) {
        phone = "+41" + phone.substring(1);
      }

      setFormData({
        ...formData,
        ...customer,
        ...{
          primary_address_id: customer.primary_address?.id,
          zip_code: customer.primary_address?.zip_code,
          state: customer.primary_address?.state,
          state_code: customer.primary_address?.state_code,
          street: customer.primary_address?.street,
          street_number: customer.primary_address?.street_number,
          city: customer.primary_address?.city,
          country: customer.primary_address?.country,
          country_code: customer.primary_address?.country_code,
          longitude: customer.primary_address?.longitude,
          latitude: customer.primary_address?.latitude,
          phone
        },
      });
      if (customer.primary_address?.state) {
        setSelectedState({
          value: customer.primary_address?.state,
          label: customer.primary_address?.state
        })
      }
      if (customer.primary_address?.longitude) {
        setCoordinate({
          lat: customer.primary_address?.latitude,
          lng: customer.primary_address?.longitude,
        })
      }
      setFile(null);
      setFileName("");

    }
    setShowMap(false);
    setIsOpen(true);
  }



  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    //subtitle.style.color = '#f00';
  }

  function closeModal() {
    setFormData({
      id: null, //
      civility: null,
      firstname: "",
      lastname: "",
      phone: "",
      email: "",
      birthdate: "",
      zip_code: "",
      state: "",
      state_code: "",
      street: "",
      street_number: "",
      city: "",
      country: "Switzerland",
      country_code: "CH",
      role: "ROLE_CLIENT",
      latitude: null,
      longitude: null
    });
    setCoordinate({
      lat: 46.356,
      lng: 6.5641
    })
    setIsAddressUpdate(false);
    setIsOpen(false);
    setSelectedState(null);
  }

  const handleFilterSubmit = async (e) => {
    e.preventDefault();
    if (filterData.search != '') {
      filters[filterData.search_by] = `${filterData.operator}:${filterData.search}`;
    }

    if (filterData.status != '') {
      filters.status = filterData.status
    }
    await fetchCustomers();
  }

  const handleFilterChange = async (e) => {
    const target = e.target;

    if (target.name === 'search_by') {
      const search = document.querySelector('input[name="search"]');

      search.setAttribute('placeholder', `Search By ${target.options[target.selectedIndex].innerHTML}`);
      filterData.search = '';
      delete filters.name;
      delete filters.phone;
      delete filters.email;
      delete filters.bookings_count;

      if (filterData.status != '') {
        filters.status = filterData.status
      }
      setFilterData({
        ...filterData,
        [target.name]: target.value
      });
      await fetchCustomers();
    } else if (target.name === 'search' && target.value === '') {
      setFilterData({
        ...filterData,
        [target.name]: target.value
      });
      delete filters.name;
      delete filters.phone;
      delete filters.email;
      delete filters.bookings_count;
      if (filterData.status != '') {
        filters.status = filterData.status
      }
      await fetchCustomers();
    } else if (target.name === 'status') {
      setFilterData({
        ...filterData,
        [target.name]: target.value
      });
      if (target.value != '') {
        filters.status = target.value
      } else {
        delete filters.status;
      }
      await fetchCustomers();
    }

    setFilterData({
      ...filterData,
      [target.name]: target.value
    });
  }

  const blockUser = async (user) => {
    await UserService.update(user.id, { status: 'BLOCKED' }, api);
    fetchCustomers();
  }

  const unblockUser = async (user) => {
    await UserService.update(user.id, { status: 'ACTIVE' }, api);
    fetchCustomers();
  }

  const fetchCoordinates = async () => {
    const { street_number, street, city, state, zip_code } = formData;
    const address = `${street_number} ${street}, ${city}, ${state} ${zip_code}`;

    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json`,
        {
          params: {
            address,
            key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
          },
        }
      );

      if (response.data.results.length > 0) {
        const location = response.data.results[0].geometry.location;
        setFormData({
          ...formData,
          latitude: location.lat,
          longitude: location.lng,
        });
        setCoordinate({
          lat: location.lat,
          lng: location.lng
        });
      } else {
        console.error('No results found for the given address.');
      }
    } catch (error) {
      console.error('Error fetching coordinates:', error);
    }
  };

  const handleCoordinateChange = (coordinates) => {
    setFormData({
      ...formData,
      longitude: coordinates[0]?.lng,
      latitude: coordinates[0]?.lat,
    })
    setCoordinate({
      lat: coordinates[0]?.lng,
      lng: coordinates[0]?.lat,
    })
  }

  const handleShowMap = async () => {
    if (!showMap) {
      await fetchCoordinates();
      setShowMap(true);
    } else {
      setShowMap(false);
    }
  };

  const handleEditMouseEnter = (index) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setHoveredRow(index);
  };

  const handleEditMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setHoveredRow(null);
    }, 250);
  };

  // Open Details Modal
  const openDetailsModal = (customer) => {
    setSelectedCustomer(customer);
    setDetailsModalIsOpen(true);
  };
  const openFicheModal = (customer) => {
    setSelectedCustomer(customer);
    setFicheFormData(
      {
        id: customer.fiche_client[0]?.id,
        user_id: customer.fiche_client[0]?.user_id,
        parking: customer.fiche_client[0]?.parking,
        maison_ou_immeuble: customer.fiche_client[0]?.maison_ou_immeuble,
        infos_logistiques: customer.fiche_client[0]?.infos_logistiques,
        tensions_particulieres: customer.fiche_client[0]?.tensions_particulieres,
        pression_ideale: customer.fiche_client[0]?.pression_ideale,
        huile_preferee: customer.fiche_client[0]?.huile_preferee,
        type_musique: customer.fiche_client[0]?.type_musique,
        problemes_physique: customer.fiche_client[0]?.problemes_physique,
        parties_preferees: customer.fiche_client[0]?.parties_preferees,
        parties_a_ne_pas_masser: customer.fiche_client[0]?.parties_a_ne_pas_masser,
        se_fait_masser_nu: customer.fiche_client[0]?.se_fait_masser_nu,
        mauvaise_hygiene: customer.fiche_client[0]?.mauvaise_hygiene,
        remarque_deplacee: customer.fiche_client[0]?.remarque_deplacee,
        age: customer.fiche_client[0]?.age,
        type_profession: customer.fiche_client[0]?.type_profession,
        source: customer.fiche_client[0]?.source,
        classe_sociale: customer.fiche_client[0]?.classe_sociale,
        parking_on: customer.fiche_client[0]?.parking_on,
        infos_logistiques_on: customer.fiche_client[0]?.infos_logistiques_on,
        maison_ou_immeuble_on: customer.fiche_client[0]?.maison_ou_immeuble_on,
        problemes_physique_on: customer.fiche_client[0]?.problemes_physique_on,
        couleur_on: customer.fiche_client[0]?.couleur_on,
        forme_on: customer.fiche_client[0]?.forme_on,
        cuticules_on: customer.fiche_client[0]?.cuticules_on,
        ongle_on: customer.fiche_client[0]?.ongle_on,
        age_on: customer.fiche_client[0]?.age_on,
        type_on: customer.fiche_client[0]?.type_on,
        entendu_on: customer.fiche_client[0]?.entendu_on,
        classe_on: customer.fiche_client[0]?.classe_on,
        info_on: customer.fiche_client[0]?.info_on,
        info_complementaires: customer.fiche_client[0]?.info_complementaires,
      }
    )
    setDetailsModalIsOpenFiche(true);

  };

  // Close Details Modal
  const closeDetailsModal = () => {
    setSelectedCustomer(null);
    setDetailsModalIsOpen(false);
  };

  const closeFichesModal = () => {
    setSelectedCustomer(null);
    setFicheFormData(
      {
        id: '',
        user_id: '',
        parking: '',
        maison_ou_immeuble: '',
        infos_logistiques: '',
        tensions_particulieres: '',
        pression_ideale: '',
        huile_preferee: '',
        type_musique: '',
        problemes_physique: '',
        parties_preferees: '',
        parties_a_ne_pas_masser: '',
        se_fait_masser_nu: '',
        mauvaise_hygiene: '',
        remarque_deplacee: '',
        age: '',
        type_profession: '',
        source: '',
        classe_sociale: '',
        parking_on: '',
        infos_logistiques_on: '',
        maison_ou_immeuble_on: '',
        problemes_physique_on: '',
        couleur_on: '',
        forme_on: '',
        cuticules_on: '',
        ongle_on: '',
        age_on: '',
        type_on: '',
        entendu_on: '',
        classe_on: '',
        info_on: '',
        info_complementaires: '',
      }
    )
    setDetailsModalIsOpenFiche(false);
  };

  // Open History Modal
  const openHistoryModal = async (customer) => {
    setSelectedCustomer(customer);
    try {
      const response = await BookingService.index({ with: 'ratings,address,client.roles,products.category,creator,editor,therapists,therapists.media,id,transactions,hotel,hotel.address', client_id: customer.id, sort: '-created_at', },
        api
      );
      console.log({ response })
      setCustomerBookings(response);
      setSelectedHistoryBookingId(response?.[0]?.id ?? null);
    } catch (error) {

    }
    setHistoryModalIsOpen(true);
  };

  useEffect(() => {
    if (!openHistoryRequested || autoHistoryOpenedRef.current || customers.length !== 1) return;

    autoHistoryOpenedRef.current = true;
    openHistoryModal(customers[0]);
  }, [customers, openHistoryRequested]);

  useEffect(() => {
    if (!customerBookings?.length) return;

    const fetchPromos = async () => {
      const promos = {};

      const uniqueCodes = [
        ...new Set(
          customerBookings
            .map(getAdminPromoCode)
            .filter(Boolean)
        )
      ];

      await Promise.all(
        uniqueCodes.map(async (code) => {
          try {
            const res = await PromotionService.index({ code }, api);
            if (res?.length) {
              promos[code] = res[0];
            }
          } catch (e) {
            console.error(`Promo fetch failed for ${code}`, e);
          }
        })
      );

      setPromoMap(promos);
    };

    fetchPromos();
  }, [customerBookings]);

  const getAdminPromoCode = (booking) => {
    const value = booking?.admin_promocode || booking?.raw_promocode || booking?.promocode || "";
    return typeof value === "string" ? value.trim() : "";
  };


  const formatPromo = (promo) => {
    if (!promo) return "N/A";

    if (promo.type === "FREE") return t("dashboard:promo.free");

    let unit = "";
    let prefix = "-";

    if (promo.type === "DURATION") {
      unit = " min";
      prefix = "";
    }
    else if (promo.type === "FLAT_OFF") unit = " CHF";
    else unit = "%";

    return `${prefix}${promo.amount}${unit} -`;
  };

  // Close History Modal
  const closeHistoryModal = () => {
    setSelectedCustomer(null);
    setCustomerBookings([]);
    setSelectedHistoryBookingId(null);
    setPromoMap({});
    setHistoryModalIsOpen(false);
  };

  const handleDelete = async (id) => {
    try {
      const response = await UserService.delete(id, api);
      fetchCustomers();
    } catch (error) {

    }
  };

  const handlePlaceSelect = (place) => {
    const zipCode = place.address_components.find((component) =>
      component.types.includes("postal_code")
    )?.long_name;

    const addressComponents = place.address_components;
    const updatedAddress = {
      street: '',
      city: '',
      zip_code: '',
      street_number: '',
      state: '',
      state_code: '',
      country: 'Switzerland',
      country_code: 'CH',
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    };

    if (zipCode) {
      setFormData((prev) => ({ ...prev, zip_code: zipCode }));
      setIsZipCodeVisible(false);
    } else {
      setIsZipCodeVisible(true);
    }

    addressComponents.forEach(component => {
      const type = component.types[0];
      switch (type) {
        case 'street_number':
          updatedAddress.street_number = component.long_name;
          break;
        case 'route':
          updatedAddress.street = component.long_name;
          break;
        case 'locality':
          updatedAddress.city = component.long_name;
          break;
        case 'postal_code':
          updatedAddress.zip_code = component.long_name;
          break;
        case 'administrative_area_level_1':
          updatedAddress.state = component.long_name;
          updatedAddress.state_code = component.short_name;
          break;
      }
    });
    setCoordinate({ lat: updatedAddress.lat, lng: updatedAddress.lng });

    setFormData((prev) => ({
      ...prev,
      street: updatedAddress.street,
      street_number: updatedAddress.street_number,
      city: updatedAddress.city,
      state: updatedAddress.state,
      zip_code: updatedAddress.zip_code,
      state_code: updatedAddress.state_code,
      latitude: updatedAddress.lat,
      longitude: updatedAddress.lng,
    }));
    setShowMap(false);
  };

  const handleClick = (event, index) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
  };


  const handleClose = () => {
    setAnchorEl(null);
    setSelectedIndex(null);
  };

  const [activeTab, setActiveTab] = useState('form');

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  const [filterMenuAnchor, setFilterMenuAnchor] = useState(null);
  const filterMenuOpen = Boolean(filterMenuAnchor);

  const handleFilterMenuClick = (event) => {
    setFilterMenuAnchor(event.currentTarget);
  };

  const handleFilterMenuClose = () => {
    setFilterMenuAnchor(null);
  };

  const historyBookings = translatedBookings || [];
  const selectedHistoryBooking = historyBookings.find(
    (booking) => booking.id === selectedHistoryBookingId
  ) || historyBookings[0];

  const getBookingProductsLabel = (booking) => (
    booking?.products?.length
      ? booking.products.map((product) => `${product?.category?.title || '-'} - ${product.duration} min`).join(', ')
      : '-'
  );

  const getBookingPriceLabel = (booking) => {
    const total = booking?.products?.reduce((sum, product) => sum + Number(product.price || 0), 0);
    const promoCode = getAdminPromoCode(booking);
    const promo = promoCode ? promoMap[promoCode] : null;
    const promoLabel = promo ? `${formatPromo(promo)} ${promoCode}` : 'N/A';

    return `${t('dashboard:table.prices')}: ${booking?.subtotal ?? '-'} CHF | Total: ${Number.isFinite(total) ? total : '-'} CHF | Code Promo: ${promoLabel}`;
  };

  const renderHistoryField = (label, value, options = {}) => (
    <div className={`booking-history-field ${options.wide ? 'booking-history-field--wide' : ''}`}>
      <span>{label}</span>
      <strong>{value || '-'}</strong>
    </div>
  );

  return (
    <>
      <MenuHeader />
      <div className="bloc-search bloc-search-mobile">
        <div className="container">
          <div className="desktop-hidden">
            <IconButton onClick={handleFilterMenuClick}>
              <img src='assets/images/filter.png' alt='actions' height={20} />
            </IconButton>
            <Menu anchorEl={filterMenuAnchor}
              open={filterMenuOpen}
              onClose={handleFilterMenuClose}
            >
              <MenuList
                style={{ padding: 0 }}
              >
                <MenuItem onClick={handleFilterMenuClose} disableRipple>
                  <ListItemIcon>
                    <img src='assets/images/filter.png' alt='actions' height={20} />

                  </ListItemIcon>
                  <ListItemText>Filters</ListItemText>
                </MenuItem>
                <Divider></Divider>
                <form onSubmit={handleFilterSubmit} className="search" style={{ padding: 10 }}>
                  <div className="text-search">
                    <input
                      type={filterData.search_by === 'bookings_count' ? 'number' : 'text'}
                      min={filterData.search_by === 'bookings_count' ? 0 : undefined}
                      name="search"
                      value={filterData.search}
                      onChange={handleFilterChange}
                      placeholder={t('searchByName')}
                      className="form-text"
                    />
                    <input type="submit" className="form-submit" value={t('search')} />
                  </div>
                  <div className="bloc-filtre">
                    <select
                      name="search_by"
                      value={filterData.search_by}
                      onChange={handleFilterChange}
                    >
                      <option value="name">{t('searchOptions.name')}</option>
                      <option value="email">{t('searchOptions.email')}</option>
                      <option value="phone">{t('searchOptions.phone')}</option>
                      <option value="bookings_count">{t('bookingCount')}</option>
                    </select>
                    <select
                      name="operator"
                      value={filterData.operator}
                      onChange={handleFilterChange}
                    >
                      <option value="contains">{t('operators.contains')}</option>
                      <option value="starts">{t('operators.starts')}</option>
                      <option value="ends">{t('operators.ends')}</option>
                      <option value="eq">{t('operators.eq')}</option>
                      <option value="!eq">{t('operators.notEq')}</option>
                      <option value="in">{t('operators.in')}</option>
                      <option value="gt">{t('operators.gt')}</option>
                      <option value="gte">{t('operators.gte')}</option>
                      <option value="lt">{t('operators.lt')}</option>
                      <option value="lte">{t('operators.lte')}</option>
                    </select>
                    <select
                      name="status"
                      value={filterData.status}
                      onChange={handleFilterChange}
                    >
                      <option value="">{t('statusOptions.all')}</option>
                      <option value="ACTIVE">{t('statusOptions.active')}</option>
                      <option value="BLOCKED">{t('statusOptions.blocked')}</option>
                      <option value="PENDING_EMAIL_VERIFICATION">{t('statusOptions.pendingEmailVerification')}</option>
                      <option value="PENDING_PHONE_VERIFICATION">{t('statusOptions.pendingPhoneVerification')}</option>
                    </select>
                  </div>
                </form>
              </MenuList>
            </Menu>
            <IconButton className="icon-excel" style={{ width: 40 }} onClick={handleDownload}>
              <img src='assets/images/icon-excel.svg' alt='actions' />
            </IconButton>
          </div>
          <div className="mobile-hidden">
            <form onSubmit={handleFilterSubmit} className="search " style={{ padding: 10 }}>
              <div className="text-search">
                <input
                  type={filterData.search_by === 'bookings_count' ? 'number' : 'text'}
                  min={filterData.search_by === 'bookings_count' ? 0 : undefined}
                  name="search"
                  value={filterData.search}
                  onChange={handleFilterChange}
                  placeholder={t('searchByName')}
                  className="form-text"
                />
                <input type="submit" className="form-submit" value={t('search')} />
              </div>
              <div className="bloc-filtre">
                <select
                  name="search_by"
                  value={filterData.search_by}
                  onChange={handleFilterChange}
                >
                  <option value="name">{t('searchOptions.name')}</option>
                  <option value="email">{t('searchOptions.email')}</option>
                  <option value="phone">{t('searchOptions.phone')}</option>
                  <option value="bookings_count">{t('bookingCount')}</option>
                </select>
                <select
                  name="operator"
                  value={filterData.operator}
                  onChange={handleFilterChange}
                >
                  <option value="contains">{t('operators.contains')}</option>
                  <option value="starts">{t('operators.starts')}</option>
                  <option value="ends">{t('operators.ends')}</option>
                  <option value="eq">{t('operators.eq')}</option>
                  <option value="!eq">{t('operators.notEq')}</option>
                  <option value="in">{t('operators.in')}</option>
                  <option value="gt">{t('operators.gt')}</option>
                  <option value="gte">{t('operators.gte')}</option>
                  <option value="lt">{t('operators.lt')}</option>
                  <option value="lte">{t('operators.lte')}</option>
                </select>
                <select
                  name="status"
                  value={filterData.status}
                  onChange={handleFilterChange}
                >
                  <option value="">{t('statusOptions.all')}</option>
                  <option value="ACTIVE">{t('statusOptions.active')}</option>
                  <option value="BLOCKED">{t('statusOptions.blocked')}</option>
                  <option value="PENDING_EMAIL_VERIFICATION">{t('statusOptions.pendingEmailVerification')}</option>
                  <option value="PENDING_PHONE_VERIFICATION">{t('statusOptions.pendingPhoneVerification')}</option>
                </select>
                <IconButton className="icon-excel" style={{ width: 40 }} onClick={handleDownload}>
                  <img src='assets/images/icon-excel.svg' alt='actions' />
                </IconButton>
              </div>
            </form>
          </div>
          <button onClick={openModal} className="btn-add-client">
            {t('add')}
          </button>
        </div>
      </div>

      <div className="tableau-list view-mobile view-rows">
        <div className="container">
          {customers?.length > 0 ? (
            customers.map((customer, index) => (
              <div className="list-items" key={customer.id}>
                <div className="img-items">
                  <img
                    src={`${customer.media[0]?.original_url}`}
                    alt={t('alt.clientImage')}
                    style={{ width: "50px", height: "50px" }}
                  />
                </div>
                <div className="infos-items">
                  <div>{customer.id}</div>
                  <div>Name : {customer.firstname} {customer.lastname}</div>
                  <div>Phone : {customer.phone}</div>
                  <div>Email : {customer.email}</div>
                  <div>Registration Date : {castDate(customer.created_at || new Date())}</div>
                  <div>{t('bookingCount')} : {customer.bookings_count ?? 0}</div>
                  <div className={customer?.status?.toLowerCase()}>
                    Status : <span>{asTitle(customer.status)}</span>
                  </div>
                  <div>
                    VIP : {customer.vip ? t('vip') : t('notVip')}
                    <AntSwitch
                      defaultChecked={customer.vip}
                      onChange={async (event) => {
                        try {
                          const response = await UserService.update(customer.id, { vip: event.target.checked }, api);
                          fetchCustomers();
                        } catch (error) {
                          console.error("Error updating vip:", error);
                        }
                      }}
                      inputProps={{ "aria-label": "ant design" }}
                    />
                  </div>
                </div>
                <div className="menu-edit">
                  <IconButton onClick={(event) => handleClick(event, index)}>
                    <MoreVertIcon />
                  </IconButton>

                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl) && selectedIndex === index} // Open menu for clicked row only
                    onClose={handleClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                  >
                    <MenuList style={{ minWidth: 180 }}>
                      <MenuItem onClick={() => { handleClose(); openFicheModal(customer); }}>
                        <ListItemIcon>
                          <EditIcon style={{ color: "#1976d2" }} />
                        </ListItemIcon>
                        <ListItemText>{t('showClientQuestionnaire')}</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => { handleClose(); openModal(customer); }}>
                        <ListItemIcon>
                          <EditIcon style={{ color: "#1976d2" }} />
                        </ListItemIcon>
                        <ListItemText>{t('editCustomer')}</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => { handleClose(); openDetailsModal(customer); }}>
                        <ListItemIcon>
                          <VisibilityIcon style={{ color: "#1976d2" }} />
                        </ListItemIcon>
                        <ListItemText>{t('viewDetails')}</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => { handleClose(); openHistoryModal(customer); }}>
                        <ListItemIcon>
                          <HistoryIcon style={{ color: "#1976d2" }} />
                        </ListItemIcon>
                        <ListItemText>{t('viewBookingHistory')}</ListItemText>
                      </MenuItem>
                      {customer.status !== 'BLOCKED' && (
                        <MenuItem style={{ color: 'red' }} onClick={() => { handleClose(); blockUser(customer); }}>
                          <ListItemIcon>
                            <BlockIcon style={{ color: "#FF5733" }} />
                          </ListItemIcon>
                          <ListItemText>{t('blockAccount')}</ListItemText>
                        </MenuItem>
                      )}
                      {customer.status !== 'ACTIVE' && (
                        <MenuItem style={{ color: 'green' }} onClick={() => { handleClose(); unblockUser(customer); }}>
                          <ListItemIcon>
                            <CheckCircleIcon style={{ color: "#28A745" }} />
                          </ListItemIcon>
                          <ListItemText>{t('activateAccount')}</ListItemText>
                        </MenuItem>
                      )}
                      <MenuItem style={{ color: 'red' }} onClick={() => { handleClose(); handleDelete(customer.id); }}>
                        <ListItemIcon>
                          <DeleteIcon style={{ color: "red" }} />
                        </ListItemIcon>
                        <ListItemText>{t('delete')}</ListItemText>
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </div>
              </div>
            ))
          ) : (
            <tr>
              <td colSpan="8">{t('noClientFound')}</td>
            </tr>
          )}
        </div>
      </div>

      <div className="tableau-list  view-desktop">
        <div className="container">
          <div className="sticky-table-container">
            <table className="sticky-table">
              <thead>
                <tr>
                  <th className="sort-header active" id='id' onClick={handleSelectedSort}>{t('customerId')}</th>
                  <th>{t('image')}</th>
                  <th className="sort-header" id='name' onClick={handleSelectedSort}>{t('name')}</th>
                  <th className="sort-header" id='phone' onClick={handleSelectedSort}>{t('phone')}</th>
                  <th className="sort-header" id='email' onClick={handleSelectedSort}>{t('email')}</th>
                  <th className="sort-header" id='created_at' onClick={handleSelectedSort}>{t('registrationDate')}</th>
                  <th className="sort-header" id='status' onClick={handleSelectedSort}>{t('statusLabel')}</th>
                  <th className="sort-header" id='bookings_count' onClick={handleSelectedSort}>{t('bookingCount')}</th>
                  <th className="sort-header" id='vip' onClick={handleSelectedSort}>{t('vip')}</th>
                  <th>{t('actions')}</th>
                </tr>
              </thead>
              <tbody>
                {customers?.length > 0 ? (
                  customers.map((customer, index) => (
                    <tr key={customer.id}>
                      <td>{customer.id}</td>
                      <td>
                        <img
                          src={`${customer.media[0]?.original_url}`}
                          alt={t('alt.clientImage')}
                          style={{ width: "50px", height: "50px" }}
                        />
                      </td>
                      <td onClick={() => { openDetailsModal(customer); }} style={{ cursor: 'pointer' }}>{customer.firstname} {customer.lastname}</td>
                      <td>{customer.phone}</td>
                      <td>{customer.email}</td>
                      <td>{castDate(customer.created_at || new Date())}</td>
                      <td className={customer?.status?.toLowerCase()}>
                        {asTitle(customer.status)}
                      </td>
                      <td>{customer.bookings_count ?? 0}</td>
                      <td>
                        {customer.vip ? t('vip') : t('notVip')}
                        <AntSwitch
                          defaultChecked={customer.vip}
                          onChange={async (event) => {
                            try {
                              const response = await UserService.update(customer.id, { vip: event.target.checked }, api);
                              fetchCustomers();
                            } catch (error) {
                              console.error("Error updating vip:", error);
                            }
                          }}
                          inputProps={{ "aria-label": "ant design" }}
                        />
                      </td>
                      <td>
                        <IconButton onClick={(event) => handleClick(event, index)}>
                          <MoreVertIcon />
                        </IconButton>

                        <Menu
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl) && selectedIndex === index} // Open menu for clicked row only
                          onClose={handleClose}
                          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                          transformOrigin={{ vertical: "top", horizontal: "right" }}
                        >
                          <MenuList style={{ minWidth: 180 }}>
                            <MenuItem onClick={() => { handleClose(); openFicheModal(customer); }}>
                              <ListItemIcon>
                                <EditIcon style={{ color: "#1976d2" }} />
                              </ListItemIcon>
                              <ListItemText>{t('showClientQuestionnaire')}</ListItemText>
                            </MenuItem>
                            <MenuItem onClick={() => { handleClose(); openModal(customer); }}>
                              <ListItemIcon>
                                <EditIcon style={{ color: "#1976d2" }} />
                              </ListItemIcon>
                              <ListItemText>{t('editCustomer')}</ListItemText>
                            </MenuItem>
                            <MenuItem onClick={() => { handleClose(); openDetailsModal(customer); }}>
                              <ListItemIcon>
                                <VisibilityIcon style={{ color: "#1976d2" }} />
                              </ListItemIcon>
                              <ListItemText>{t('viewDetails')}</ListItemText>
                            </MenuItem>
                            <MenuItem onClick={() => { handleClose(); openHistoryModal(customer); }}>
                              <ListItemIcon>
                                <HistoryIcon style={{ color: "#1976d2" }} />
                              </ListItemIcon>
                              <ListItemText>{t('viewBookingHistory')}</ListItemText>
                            </MenuItem>
                            {customer.status !== 'BLOCKED' && (
                              <MenuItem style={{ color: 'red' }} onClick={() => { handleClose(); blockUser(customer); }}>
                                <ListItemIcon>
                                  <BlockIcon style={{ color: "#FF5733" }} />
                                </ListItemIcon>
                                <ListItemText>{t('blockAccount')}</ListItemText>
                              </MenuItem>
                            )}
                            {customer.status !== 'ACTIVE' && (
                              <MenuItem style={{ color: 'green' }} onClick={() => { handleClose(); unblockUser(customer); }}>
                                <ListItemIcon>
                                  <CheckCircleIcon style={{ color: "#28A745" }} />
                                </ListItemIcon>
                                <ListItemText>{t('activateAccount')}</ListItemText>
                              </MenuItem>
                            )}
                            <MenuItem style={{ color: 'red' }} onClick={() => { handleClose(); handleDelete(customer.id); }}>
                              <ListItemIcon>
                                <DeleteIcon style={{ color: "red" }} />
                              </ListItemIcon>
                              <ListItemText>{t('delete')}</ListItemText>
                            </MenuItem>
                          </MenuList>
                        </Menu>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10">{t('noClientFound')}</td>
                  </tr>
                )}
              </tbody>
              <tfoot >
                <tr>
                  <td colSpan={10}>
                    <div className="paginator">
                      <select value={perPage} onChange={handlePerPageChange} className="per-page">
                        <option value={1}>1</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={250}>250</option>
                        <option value={500}>500</option>
                        <option value={1000}>1000</option>
                      </select>
                      <div className="total">{t('totalRecords')}: {total}</div>
                      <div className="pagination">
                        <button type="button" disabled={currentPage === 1} onClick={handleFirstPage}>{'<<'}</button>
                        <button type="button" disabled={currentPage === 1} onClick={handlePrevPage}>{'<'}</button>
                        <span>{t('pagination.page', { current: currentPage, total: lastPage })}</span>
                        <button type="button" disabled={currentPage === lastPage} onClick={handleNextPage}>{'>'}</button>
                        <button type="button" disabled={currentPage === lastPage} onClick={handleLastPage}>{'>>'}</button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>

      <Modal
        isOpen={detailsModalIsOpen}
        onRequestClose={closeDetailsModal}
        style={customStyles}
      >
        <button className="close-button" onClick={closeDetailsModal}>
          <span className="close-icon">✖</span>
        </button>
        {selectedCustomer && (
          <div className="form-inscription mrgBottom">
            <h2>{t('details')} {selectedCustomer.extra.full_name}</h2><br />
            <form>
              <div className="input-hotel-container">
                <label className="input-hotel-label">{t('customerId')}:</label>
                <input type="text" name="id" value={selectedCustomer.id} readOnly />
              </div>
              <div className="input-hotel-container">
                <label className="input-hotel-label">{t('civility')}:</label>
                <input type="text" name="civility" value={t(selectedCustomer?.civility?.toLowerCase?.() ?? '-')} readOnly />
              </div>
              <div className="input-hotel-container">
                <label className="input-hotel-label">{t('fullName')}:</label>
                <input type="text" name="name" value={`${selectedCustomer.firstname} ${selectedCustomer.lastname}`} readOnly />
              </div>
              <div className="input-hotel-container">
                <label className="input-hotel-label">{t('email')}:</label>
                <input type="email" name="email" value={selectedCustomer.email} readOnly />
              </div>
              <div className="input-hotel-container">
                <label className="input-hotel-label">{t('phone')}:</label>
                <input type="tel" name="phone" value={selectedCustomer.phone} readOnly />
              </div>
              <div className="input-hotel-container">
                <label className="input-hotel-label">{t('Address')}:</label>
                <input
                  type="text"
                  name="address"
                  value={
                    `${selectedCustomer.primary_address?.street_number || ''} ` +
                    `${selectedCustomer.primary_address?.street || ''}, ` +
                    `${selectedCustomer.primary_address?.zip_code || ''}, ` +
                    `${selectedCustomer.primary_address?.state || ''}`
                  }
                  readOnly
                />
              </div>
              <div className="input-hotel-container">
                <label className="input-hotel-label">{t('registrationDate')}:</label>
                <input type="text" name="registration_date" value={castDate(selectedCustomer.created_at || new Date())} readOnly />
              </div>
              <div className="input-hotel-container">
                <label className="input-hotel-label">{t('birthdate')}:</label>
                <input type="text" name="birthdate" value={selectedCustomer?.birthdate ? castDate(selectedCustomer.birthdate) : '-'} readOnly />
              </div>
              <div className="input-hotel-container">
                <label className="input-hotel-label">{t('status')}:</label>
                <input type="text" name="status" value={asTitle(selectedCustomer.status)} readOnly />
              </div>
            </form>
          </div>
        )}
      </Modal>

      <Modal
        isOpen={historyModalIsOpen}
        onRequestClose={closeHistoryModal}
        style={historyModalStyles}
      >
        <button className="close-button" onClick={closeHistoryModal}>
          <span className="close-icon">✖</span>
        </button>
        <div className="booking-history-header">
          <div>
            <h2>{t('bookingHistoryTitle', { name: selectedCustomer?.extra?.full_name || `${selectedCustomer?.firstname || ''} ${selectedCustomer?.lastname || ''}`.trim() })}</h2>
            <p>{t('bookingHistoryCount', { count: historyBookings.length })}</p>
          </div>
        </div>

        {historyBookings.length > 0 ? (
          <div className="booking-history-layout">
            <div className="booking-history-list">
              {historyBookings.map((booking) => (
                <button
                  type="button"
                  key={booking.id}
                  className={`booking-history-card ${selectedHistoryBooking?.id === booking.id ? 'booking-history-card--active' : ''}`}
                  onClick={() => setSelectedHistoryBookingId(booking.id)}
                >
                  <span className="booking-history-card__top">
                    <strong>#{booking.id}</strong>
                    <StatusBadge status={booking.status} namespace="statusManager" />
                  </span>
                  <span>{castDate(booking.start_before)}</span>
                  <small>{getBookingProductsLabel(booking)}</small>
                  <small>{addressFormat(booking.address)}</small>
                  {!!booking.therapists?.length && (
                    <span className="booking-history-card__flypros">
                      {booking.therapists.map((therapist) => (
                        <span key={therapist.id || therapist.extra?.full_name} className="booking-history-card__flypro">
                          {therapist?.media?.[0]?.original_url ? (
                            <img src={therapist.media[0].original_url} alt={therapist.extra?.full_name || 'Flypro'} />
                          ) : (
                            <span className="booking-history-card__flypro-placeholder">
                              {(therapist?.extra?.full_name || 'F').charAt(0)}
                            </span>
                          )}
                          <span>{therapist?.extra?.full_name || '-'}</span>
                        </span>
                      ))}
                    </span>
                  )}
                </button>
              ))}
            </div>

            {selectedHistoryBooking && (
              <div className="booking-history-detail">
                <div className="booking-history-detail__title">
                  <div>
                    <span>{t('dashboard:table.orderId')}</span>
                    <h3>#{selectedHistoryBooking.id}</h3>
                  </div>
                  <StatusBadge status={selectedHistoryBooking.status} namespace="statusManager" />
                </div>

                <div className="booking-history-section">
                  <h4>{t('dashboard:modal.bookingDetails.title')}</h4>
                  <div className="booking-history-grid">
                    {renderHistoryField(t('dashboard:modal.bookingDetails.labels.startBefore'), castDate(selectedHistoryBooking.start_before))}
                    {renderHistoryField(t('dashboard:modal.bookingDetails.labels.completeBefore'), castDate(new Date(new Date(selectedHistoryBooking.start_before).getTime() + selectedHistoryBooking.duration * 60 * 1000)))}
                    {renderHistoryField(t('dashboard:modal.duration'), `${selectedHistoryBooking.duration} min`)}
                    {renderHistoryField('Duo', selectedHistoryBooking.therapists?.length === 2 ? 'Oui' : 'Non')}
                    {renderHistoryField(t('dashboard:modal.bookingDetails.labels.refundType'), selectedHistoryBooking.refund_type ? t(`refundType.${selectedHistoryBooking.refund_type}`) : '-')}
                    {renderHistoryField(t('dashboard:table.teamName'), selectedHistoryBooking.address?.state || '-')}
                  </div>
                </div>

                <div className="booking-history-section">
                  <h4>{t('dashboard:table.product')}</h4>
                  <div className="booking-history-grid">
                    {renderHistoryField(t('dashboard:table.product'), getBookingProductsLabel(selectedHistoryBooking), { wide: true })}
                    {renderHistoryField(t('dashboard:table.productprice'), selectedHistoryBooking.products?.map(product => `${product.duration} min = ${product.price} CHF`).join(', ') || '-', { wide: true })}
                    {renderHistoryField('Total', getBookingPriceLabel(selectedHistoryBooking), { wide: true })}
                  </div>
                </div>

                <div className="booking-history-section">
                  <h4>{t('dashboard:modal.bookingDetails.labels.flyingDetails')}</h4>
                  <div className="booking-history-flypros">
                    {selectedHistoryBooking.therapists?.length ? selectedHistoryBooking.therapists.map((therapist) => (
                      <div key={therapist.id || therapist.extra?.full_name} className="booking-history-flypro">
                        {therapist?.media?.[0]?.original_url && (
                          <img src={therapist.media[0].original_url} alt={therapist.extra?.full_name || 'Therapist'} />
                        )}
                        <span>{therapist?.extra?.full_name || '-'}</span>
                      </div>
                    )) : '-'}
                  </div>
                </div>

                <div className="booking-history-section">
                  <h4>{t('dashboard:table.description')}</h4>
                  <div className="booking-history-notes">
                    <p><span>Message</span>{selectedHistoryBooking.message || 'N/A'}</p>
                    <p><span>Description</span>{selectedHistoryBooking.description || 'N/A'}</p>
                    <p><span>Justification</span>{selectedHistoryBooking.justification || 'N/A'}</p>
                  </div>
                </div>

                <div className="booking-history-section">
                  <h4>{t('dashboard:modal.bookingDetails.labels.createdBy')}</h4>
                  <div className="booking-history-grid">
                    {renderHistoryField(t('dashboard:modal.bookingDetails.labels.createdBy'), `${selectedHistoryBooking.creator?.extra?.full_name || '-'} - Roles: ${selectedHistoryBooking.creator?.roles?.map(role => asTitle(role.name)).join(', ') || '-'}`, { wide: true })}
                    {renderHistoryField(t('dashboard:table.createdle'), castDate(selectedHistoryBooking.created_at))}
                    {renderHistoryField(t('dashboard:table.tags'), selectedHistoryBooking.tags || '-')}
                    {renderHistoryField(t('dashboard:modal.bookingDetails.labels.rating'), selectedHistoryBooking.extra?.rating ? `⭐ ${selectedHistoryBooking.extra.rating}/5` : '-')}
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <p>{t('noBookings')}</p>
        )}
      </Modal>


      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        ariaHideApp={false}

        style={customStyles}
      >
        <h2>  {formData.id ? t('editCustomer') : t('addCustomer')}</h2>
        <div className="form-inscription">
          <form onSubmit={handleSubmit}>
            <div className="form-choix">
              <div className="form-radio">
                <input
                  type="checkbox"
                  name="civility"
                  value="MS"
                  id="madame"
                  checked={formData.civility === "MS"}
                  onChange={handleChange}
                />
                <label htmlFor="madame">{t('ms')}</label>
              </div>
              <div className="form-radio">
                <input
                  type="checkbox"
                  name="civility"
                  value="MR"
                  id="monsieur"
                  checked={formData.civility === "MR"}
                  onChange={handleChange}
                />
                <label htmlFor="monsieur">{t('mr')}</label>
              </div>
            </div>
            <div className='flex-row gap-10'>
              <div className="form-text">
                <label>{t('firstname')} *</label>
                <input required value={formData.firstname} type="text" name="firstname" onChange={handleChange} />
              </div>

              <div className="form-text">
                <label>{t('lastname')} *</label>
                <input required value={formData.lastname} type="text" name="lastname" onChange={handleChange} />
              </div>
            </div>

            <div className="form-text">
              <label>{t('phone')} *</label>
              <PhoneInput
                defaultCountry="ch"
                type="tel"
                name="phone"
                value={formData.phone}
                disableCountryGuess={false}
                //hideDropdown="true"
                forceDialCode="true"
                //onChange={handlePhoneChange}
                onChange={(phone) => handlePhoneChange(phone)}
                required
              />
            </div>

            <div className="form-text">
              <label>{t('emailAddress')} *</label>
              <input required value={formData.email} type="email" name="email" onChange={handleChange} />
            </div>

            <div className="form-text">
              <label>{t('birthdate')}</label>
              <input
                type="date"
                name="birthdate"
                value={formData.birthdate}
                onChange={handleChange}
                max={calculateMinDate()} // Date maximum permise (il y a 18 ans)
              />
            </div>
            <div className="flex-row gap-10">
              <div className="form-text">
                <label htmlFor="street">{t('selectAddress')}</label>
                <Autocomplete
                  apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                  onPlaceSelected={handlePlaceSelect}
                  options={{
                    types: ["address"],
                    componentRestrictions: { country: "CH" },
                  }}
                  style={{
                    height: "60px",
                    padding: "0 15px",
                    border: "0",
                    borderRadius: "20px",
                    boxShadow: "0px 8px 50px 0px rgba(0, 0, 0, 0.06)",
                  }}
                  defaultValue={
                    formData.street
                      ? `${formData.street_number} ${formData.street}, ${formData.city}, ${formData.state} ${formData.zip_code}`
                      : ""
                  }
                  className={`address-input ${isZipCodeVisible ? "compact" : ""}`}
                />
              </div>

              {isZipCodeVisible && (
                <div className="form-group zip-code-input">
                  <label>{t('zipCode')}</label>
                  <input
                    type="text"
                    value={formData.zip_code}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        zip_code: e.target.value,
                      }))
                    }
                    required
                  />
                </div>
              )}

              <div className="form-group icon-top-margin">
                {formData.zip_code && (
                  <img
                    src="assets/images/map-icon.svg"
                    alt={t('alt.mapIcon')}
                    className="clickable"
                    onClick={handleShowMap}
                  />
                )}
              </div>
            </div>

            {formData.latitude && showMap && (
              <Map
                coordinates={[coordinates]}
                mode="edit"
                containerStyle={{ width: '100%', height: '400px' }}
                mapOptions={{
                  disableDefaultUI: true,
                  zoomControl: true,
                  mapTypeControl: false,
                  fullscreenControl: true,
                  streetViewControl: false,
                }}
                onCoordinateChange={handleCoordinateChange}
              />
            )}

            <label className="fileLabel" htmlFor="file">
              {t('imageUpload')}
            </label>
            <div className="fileField">
              <label htmlFor="file">
                <img className="imgFile" src={imageFile || ""} alt={t('alt.fileUpload')} />
                {fileName ? (
                  <div>{t('uploadedFile')}: {fileName}</div>
                ) : (
                  <>
                    <div className="selectFileTo">{t('selectFileToUpload')}</div>
                    <div className="orDragAnd">
                      {t('dragAndDrop')}
                    </div>
                  </>
                )}
              </label>
              <input
                type="file"
                id="file"
                name="file"
                accept="image/*"
                onChange={handleChange}
                ref={fileInputRef}
                style={{ display: "none" }}
              />
            </div>
            <button type="submit" className="btn-submit">
              {formData.id ? t('updateCustomer') : t('createCustomer')}
            </button>
          </form>
        </div>
      </Modal>
      <Modal
        isOpen={detailsModalIsOpenFiche}
        onRequestClose={closeFichesModal}
        style={customStyles}
      >
        <button className="close-button" onClick={closeFichesModal}>
          <span className="close-icon">✖</span>
        </button>

        {selectedCustomer && (
          <div className="form-inscription mrgBottom">
            <div className="tabqa">
              <button className={`button btn-tabs tab ${activeTab === 'form' ? 'active' : ''}`} onClick={() => handleTabClick('form')}>
                {t('questionnaire.massages')}
              </button>
              <button
                className={`button btn-tabs tab ${activeTab === 'info' ? 'active' : ''}`} onClick={() => handleTabClick('info')}>
                {t('questionnaire.nails')}
              </button>
            </div>

            <div className="tab-content">
              {activeTab === 'form' && (
                <div className="form-section">
                  <h2>{t('questionnaire.clientQuestionnaire')} {selectedCustomer.extra.full_name}</h2>
                  <br />
                  <br />
                  <form onSubmit={handleSubmitFiche}>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.parking')}</label>
                      <input type="text" name="parking" value={ficheFormData.parking} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.homeOrBuilding')}</label>
                      <input type="text" name="maison_ou_immeuble" value={ficheFormData.maison_ou_immeuble} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.logisticsInfo')}</label>
                      <input type="text" name="infos_logistiques" value={ficheFormData.infos_logistiques} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.particularTensions')}</label>
                      <input type="text" name="tensions_particulieres" value={ficheFormData.tensions_particulieres} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.idealPressure')}</label>
                      <input type="text" name="pression_ideale" value={ficheFormData.pression_ideale} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.preferredOil')}</label>
                      <input type="text" name="huile_preferee" value={ficheFormData.huile_preferee} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.musicType')}</label>
                      <input type="text" name="type_musique" value={ficheFormData.type_musique} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.physicalIssues')}</label>
                      <input type="text" name="problemes_physique" value={ficheFormData.problemes_physique} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.preferredParts')}</label>
                      <input type="text" name="parties_preferees" value={ficheFormData.parties_preferees} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.partsToAvoid')}</label>
                      <input type="text" name="parties_a_ne_pas_masser" value={ficheFormData.parties_a_ne_pas_masser} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.massagedNude')}</label>
                      <input type="text" name="se_fait_masser_nu" value={ficheFormData.se_fait_masser_nu} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.badHygiene')}</label>
                      <input type="text" name="mauvaise_hygiene" value={ficheFormData.mauvaise_hygiene} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.inappropriateRemarks')}</label>
                      <input type="text" name="remarque_deplacee" value={ficheFormData.remarque_deplacee} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.approximateAge')}</label>
                      <input type="text" name="age" value={ficheFormData.age} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.professionType')}</label>
                      <input type="text" name="type_profession" value={ficheFormData.type_profession} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.howHeard')}</label>
                      <input type="text" name="source" value={ficheFormData.source} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.socialClass')}</label>
                      <input type="text" name="classe_sociale" value={ficheFormData.classe_sociale} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.additionalInfo')}</label>
                      <input type="text" name="info_complementaires" value={ficheFormData.info_complementaires} onChange={handleChangeFiche} />
                    </div>
                    <button type="submit" className="btn-submit">
                      {ficheFormData.id ? t('questionnaire.update') : t('questionnaire.save')}
                    </button>
                  </form>
                </div>
              )}

              {activeTab === 'info' && (
                <div className="info-section">
                  <h2>{t('questionnaire.clientQuestionnaire')} {selectedCustomer.extra.full_name}</h2>
                  <br />
                  <br />
                  <form onSubmit={handleSubmitFiche}>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.parking')}</label>
                      <input type="text" name="parking_on" value={ficheFormData.parking_on} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.logisticsInfo')}</label>
                      <input type="text" name="infos_logistiques_on" value={ficheFormData.infos_logistiques_on} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.homeOrBuilding')}</label>
                      <input type="text" name="maison_ou_immeuble_on" value={ficheFormData.maison_ou_immeuble_on} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.physicalIssues')}</label>
                      <input type="text" name="problemes_physique_on" value={ficheFormData.problemes_physique_on} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.preferredColor')}</label>
                      <input type="text" name="couleur_on" value={ficheFormData.couleur_on} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.nailShape')}</label>
                      <input type="text" name="forme_on" value={ficheFormData.forme_on} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.cuticlePreference')}</label>
                      <input type="text" name="cuticules_on" value={ficheFormData.cuticules_on} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.nailType')}</label>
                      <input type="text" name="ongle_on" value={ficheFormData.ongle_on} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.approximateAge')}</label>
                      <input type="text" name="age_on" value={ficheFormData.age_on} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.professionType')}</label>
                      <input type="text" name="type_on" value={ficheFormData.type_on} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.howHeard')}</label>
                      <input type="text" name="entendu_on" value={ficheFormData.entendu_on} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.socialClass')}</label>
                      <input type="text" name="classe_on" value={ficheFormData.classe_on} onChange={handleChangeFiche} />
                    </div>
                    <div className="input-hotel-container">
                      <label className="input-hotel-label">{t('questionnaire.additionalInfo')}</label>
                      <input type="text" name="info_on" value={ficheFormData.info_on} onChange={handleChangeFiche} />
                    </div>
                    <button type="submit" className="btn-submit">
                      {ficheFormData.id ? t('questionnaire.update') : t('questionnaire.save')}
                    </button>
                  </form>
                </div>
              )}
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default Customer;
